import { Control, FieldPath, FieldValues } from "react-hook-form";
import { FormInputNumber } from "../../../../components/ui/Input/FormInputNumber/FormInputNumber";
import { yearRules } from "../helpers/facilityValidation.helpers";

interface FacilityYearInputProps<
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
> {
  control: Control<TFieldValues>;
  name: TName;
}

const FacilityYearInput = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends FieldPath<TFieldValues> = FieldPath<TFieldValues>
>({
  control,
  name
}: FacilityYearInputProps<TFieldValues, TName>) => (
  <FormInputNumber
    control={control}
    name={name}
    label="Year"
    required
    errorMessage="Year is required"
    isYearInput
    removeDecimal
    rules={yearRules}
    placeholder="Year"
  />
);

export default FacilityYearInput;
